import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbpSessionService } from 'abp-ng2-module';
import { AddAwayTimeGetAllDto, AllDashboardServiceProxy, AddAwayTimeServiceProxy, ProjectTypeCountDto } from '../../../../../shared/service-proxies/service-proxies';


interface TimeOffInfo {
    name: string;
    value: string;
}
@Component({
  selector: 'app-leave-report-info',
  templateUrl: './leave-report-info.component.html',
  styleUrls: ['./leave-report-info.component.css']
})
export class LeaveReportInfoComponent implements OnInit {
    view: any[] = [200, 300];
    name = 'Angular';
    timeDetails: ProjectTypeCountDto[] = [];
    tempArray: any[] = [];

    timeDetailsName: string;


    isLoading: boolean = false;
    isEmpty: boolean = true;
    noData: boolean = false;

   TimeOffInfoDetails: TimeOffInfo = { name: "", value: "" };

    // colorScheme = {
    //     domain: ['#778BEB', '#FF6565', '#00823B', '#4D2626', '#3699FF', '#48637B', '#F9A44A', '#574B90', '#FB9A99','#FFD950']
    // };

    colorScheme = {
        domain: [  '#EFA130',   '#DB5AD7','#57B02B', '#E93C29', '#567480',   '#4AB7F7'] // Adjusted color codes
  };


    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy,
                private _AddAwayTimeServiceProxy: AddAwayTimeServiceProxy,
                private _abpSessionService: AbpSessionService,
                injector: Injector,
                private router:Router) { }

    ngOnInit(): void {
        this.timeOffDetails();
        // this._AddAwayTimeServiceProxy.getAllForMyTimeOff('', [], [], [], '', undefined, undefined).subscribe((y) => {
        //     console.log(y, "There");
        // });

    }

getColorForDetails(detailName: string): string {
    const colorMap = {
        'Parent leave': '#EFA130',
        'Vacation': '#4AB7F7',
        'Unpaid leave': '#567480',
        'Sick': '#E93C29',
        'Casual Leave': '#57B02B',
        'Public holiday': '#DB5AD7',
        // 'Half day': '#778BEB'
    };
    return colorMap[detailName] || ''; // Return the mapped color, or empty string if not found
}



    async timeOffDetails() {

        await this._AllDashboardServiceProxy.getTimeOffInfo('', [], [], [], '', undefined, undefined).subscribe(result => {
            result.forEach(x => {
                if (x.name == 'ParentalLeave') {
                    x.name = 'Parent leave';
                }
                else if (x.name == 'UnpaidLeave') {
                    x.name = 'Unpaid leave';
                }

                else if (x.name == 'PublicHoliday') {
                    x.name = 'Public holiday';
                }

                else if (x.name == 'CasualLeave') {
                    x.name = 'Casual Leave';
                }
                // else if (x.name == 'HalfDay') {
                //     x.name
                // }

                this.timeDetails.push(x);



            })
            //this.timeDetails = result;
            this.isLoading = true;
            result.forEach(x => {
                if (x.value) {
                    this.isEmpty = false;
                    this.noData = true;

                }
            })
        })


        // await this._AddAwayTimeServiceProxy.getAllForMyTimeOff('', [], [], [], '', undefined, undefined).subscribe((y) => {
        //     console.log(y, "There");
        //     y.forEach(z => {
        //         if(z.addTimeStatus == 3){
        //             this.timeDetails.forEach(a => {
        //                 if(z.awayTimeTypeName == a.name){
        //                 //    this.timeDetailsNew = this.timeDetails.filter((b) => b.name === z.awayTimeTypeName);
        //                     // this.timeDetailsNew.push(a);
        //                     a.value = 0;

        //                 }
        //             })

        //         }
        //     })
        // });


    }

    viewall() {
        this.router.navigate(['/app/main/Leaves/overview']);
    }

}
